import styled from "styled-components";
import { tokens } from "../../public/tokens";

const { colors, typography, globals } = tokens;

export const CHART_COLORS = ["#5B8FF9", "#5AD8A6", "#5D7092", "#F6BD16", "#6F5EF9", "#6DC8EC", "#945FB9", "#FF9845", "#1E9493", "#FF99C3"];

export const CHART_TEXT_COLOR = "#595959";

export const CHART_MARGIN = { top: 10, right: 5, bottom: 10, left: 10 };

/** Fixed-height wrapper; Recharts draws nothing inside a parent without a real height. */
export const ChartFrame = styled.div(({ $height, $marginTop = 0 }) => ({
    display: "flex",
    flexDirection: "column",
    height: `${$height}px`,
    marginTop: `${$marginTop}px`,
}));

export const ChartBody = styled.div({
    flex: 1,
    minHeight: 0,
});

/** Chart heading; the 30px left padding lines it up with the plot area and has no spacing token. */
export const ChartTitle = styled.div({
    padding: `0 0 ${globals["spacing-5"]} 30px`,
    fontFamily: "inherit",
    fontSize: typography.fontSize["xl-18px"],
    lineHeight: typography.lineHeights["110"],
    color: colors.neutral.black,
    textAlign: "left",
});
